import Portal = require("portal-gis");
import Collection = require("../collections/bookmark-collection");
let data = new Collection();

data['about'] = `Shared collection of bookmarks`;

export = data; 
